@if (display) {
	<p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{ title }}" [(visible)]="display" showEffect="fade" [modal]="true" appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
		<!-- #region BODY -->
		<div class="container-md">
			<div class="row mt-4 mb-4">
				<!-- DESCRIPTION -->
				<div class="col-sm-6">
					<label class="form-label custom-label fw-bold small mb-2 me-2" i18n>
						{{ 'general.description' | translate }}
					</label>
					<div class="p-0"></div>
					<textarea
						pInputTextarea
						id="observations"
						[(ngModel)]="entity.description"
						[rows]="5"
						[style]="{ width: '270px' }"
						[disabled]="!formManipulation"
					>
					</textarea>
				</div>
				<!-- VEHICLE -->
				<div class="col-sm-6">
					<strong
						><label for="insurance-vehicle" class="form-label custom-label fw-bold small mb-2 me-2" i18n
							>{{ 'tableManagement.vehicle.vehicle' | translate }} (*)</label
						></strong
					>
					<div class="p-0"></div>
					<p-select
						[options]="vehicleList"
						[(ngModel)]="entity.vehicle"
						placeholder="{{ 'general.select' | translate }} {{ 'tableManagement.vehicle.vehicle' | translate }}"
						dataKey="id"
						optionLabel="name"
						[style]="{ width: '250px' }"
						appendTo="body"
						[filter]="true"
						filterBy="name"
						(onChange)="onChangeVehicle($event)"
						(onFilter)="onFilterVehicle($event)"
						[disabled]="true"
					>
					</p-select>
				</div>
			</div>
			<div class="row mt-4 mb-4">
				<div class="col-sm-6">
					<strong
						><label class="form-label custom-label fw-bold small mb-2 me-2" i18n>
							{{ 'tableManagement.notes.dateNote' | translate }} (*)
						</label></strong
					>
					<div class="p-0"></div>
					<p-datepicker
						[(ngModel)]="noteDate"
						[showTime]="false"
						[style]="{ width: '200px' }"
						showIcon="true"
						appendTo="body"
						dateFormat="{{ i18n.dateFormat }}"
						[disabled]="!formManipulation"
					></p-datepicker>
				</div>

				<div class="col-sm-6"></div>
			</div>

			<!-- taula de documents -->
			@if (!isNew) {
				<div class="row mt-4 mb-4">
					<app-doc-table
						type="NOTE"
						[entity]="entity"
						[nested]="true"
						[ids]="ids"
						(return)="refresh()"
						[useDocNote]="false"
					>
					</app-doc-table>
				</div>
			}
		</div>
		<!-- #endregion BODY -->
	</div>
<!-- #region FOOTER -->
<ng-template pTemplate="footer">
			<div class="d-flex justify-content-center align-items-center">
				<div class="p-2 d-flex align-items-center">
					@if (isNew && formManipulation) {
						<div>
							<button class="btn custom-button" (click)="createNote()" [disabled]="loading" i18n>
								{{ 'general.create' | translate }}
							</button>
						</div>
					}
					@if (!isNew && formManipulation) {
						<div>
							<button class="btn custom-button" (click)="updateNote()" [disabled]="loading" i18n>
								{{ 'general.save' | translate }}
							</button>
						</div>
					}
					@if (loading) {
						<mat-spinner [diameter]="30" strokeWidth="5" [color]="red" class="ms-2"> </mat-spinner>
					}
				</div>
			</div>
		</ng-template>
<!-- #endregion FOOTER -->
</p-dialog>
}
